module.exports = __webpack_public_path__ + "static/img/til70.783c188.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/til70.png
// module id = TiWf
// module chunks = 1